import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import OptimizedImage from './OptimizedImage';
import { Link } from 'react-router-dom';
import { useFptiImpression } from '../../../lib/hooks';

const CategoryCard = props => {
  const {
    content: {
      location = '',
      categoryHeader = '',
      categoryBody = '',
      categoryImageUrl = '',
      categoryFPTI = '',
      categoryImageUrlVariant = ''
    } = {},
    fptiImpression,
    handleClick,
    isRecommendCategory = false,
    isColoredIconsEligible
  } = props;
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression({
      pageLink: categoryFPTI,
      category: 'parent'
    });
  });

  const recommendationsUrl = '/setup-recommendations?appcenter=true';
  const appCenterLocationUrl = `/appcenter/${location}`;

  const imageUrl =
    isColoredIconsEligible && categoryImageUrlVariant
      ? categoryImageUrlVariant
      : categoryImageUrl;

  return (
    <Link
      ref={ref}
      onClick={handleClick}
      to={isRecommendCategory ? recommendationsUrl : appCenterLocationUrl}
      className="category-card undo-link-styles add-focus-visible"
      style={isRecommendCategory ? { margin: '8px 0 0' } : {}}
    >
      <div className="category-card-text">
        <h3>{categoryHeader}</h3>
        <p>{categoryBody}</p>
      </div>
      <div className="category-card-image">
        <OptimizedImage
          imageUrl={imageUrl}
          className={`category-card-image-optimized`}
        />
      </div>
    </Link>
  );
};

CategoryCard.propTypes = {
  handleClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  content: PropTypes.object,
  isRecommendCategory: PropTypes.bool,
  isColoredIconsEligible: PropTypes.bool
};

export default CategoryCard;
